import Swiper from 'swiper/core';
import { Navigation, Autoplay } from 'swiper/modules';
import loaded from '@/scripts/helpers/loaded';

loaded(() => {
    document.querySelectorAll('.js--hover--play--video').forEach(function(element) {
        element.addEventListener('mouseenter', function() {
            var id = 'video__' + this.getAttribute('data-id'),
                vid = document.getElementById(id);
            if (vid) {
                vid.play();
            }
        });
        
        element.addEventListener('mouseleave', function() {
            var id = 'video__' + this.getAttribute('data-id'),
                vid = document.getElementById(id);
            if (vid) {
                vid.pause();
            }
        });
    });
});

loaded(() => {
    console.log('Featured slider init');
    const sliders = Array.from(document.querySelectorAll('.slider--js__hero'));
    if (!sliders) {
        return;
    }

    if (!sliders?.length) {
        return;
    }

    sliders.forEach((element) => {
        const speed = element.dataset.autoplaySpeed;

        new Swiper(element, {
            slidesPerView: "auto",
            effect: "fade",
            allowTouchMove: true,
            freeMode: false,
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: speed ? parseInt(speed) : 4500,
                disableOnInteraction: false,
            },
            modules: [Navigation, Autoplay],
        });

        element.style.opacity = '1';
    });

});

function scrollTo(element){
    const el = document.querySelector(element);
    if (el) {
        const targetPosition = el.offsetTop - 120;
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
}

loaded(() =>{
    document.querySelectorAll('.parent--buttons--block_A a').forEach(function(element) {
        element.addEventListener('click', function(e) {
            var href = this.getAttribute('href'),
                check = window.location.origin + window.location.pathname + '#';
            console.log('check: ',check);
            if(href.indexOf(check) != -1){
                e.preventDefault();
                var targetHref = href.replace(check,'#'),
                    targetElement = document.querySelector(targetHref);

                if(targetElement){
                    scrollTo(targetHref);
                }
                console.log('href: ',targetHref);
            }
        });
    });
});
